// extracted by mini-css-extract-plugin
module.exports = {"stickyBackground":"Cta_stickyBackground__2PDFM","stickyBackgroundSolid":"Cta_stickyBackgroundSolid__oQ1Hh"};